<template>
  <v-container class="progress-goalSetting-stress pt-0 border">
    <div v-if="goalMotivations.length">
      <v-row>
        <v-col cols="8" class="pr-8 pt-6">
          <v-row no-gutters>
            <v-col cols="9">
              <h3 class="pb-5 pl-10 pull-left">{{ $t("stress.stressReliefGoals") }}</h3>
            </v-col>
            <v-col cols="3" align="center">
              <h3>{{ $t("journeyBehaviourChangeGoals.motivation") }}</h3>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="4">
          <v-row no-gutters>
            <v-col cols="12">
              <p v-if="stressReliefGoalFormReportDate" class="pull-right mr-8 mt-1">{{ $ucfirst($t("pa.reportedOn")) }} {{ stressReliefGoalFormReportDate }}</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="8" class="pr-8 pt-6">
          <v-row v-for="goalMotivation in goalMotivations" v-bind:key="goalMotivation.text"
                 class="v-patient-overview-stress-goal-setting border my-6" no-gutters>
            <v-col cols="9">
              <v-row align="center" class="fill-height" no-gutters>
                <v-col class="pl-10">
                  <p justify="center">
                    {{ goalMotivation.text }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" class="pr-3">
              <v-row class="d-flex justify-center">
                <v-col align="center">
                  <p :class="['border', 'pa-4', 'my-2', 'status', goalMotivation.colorClass]">
                    {{ goalMotivation.motivationText }}
                  </p>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <v-row v-else align="center">
      <v-col>
        {{ $t("noData") }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import moment from "moment";

export default {
  name: "PatientOverviewStressGoalSetting",
  data: function () {
    return {
      stressReliefGoalForm: null,
    }
  },
  mounted: function () {
    this.loadData();
  },
  computed: {
    ...mapGetters({
      patientId: 'patientSummary/id',
    }),
    goalMotivations() {
      if (!this.stressReliefGoalForm?.entries.length) {
        return [];
      }

      return this.stressReliefGoalForm.entries.map(entry => {
        return {
          text: entry.question.text,
          motivationText: entry.givenAnswers[0].text,
          colorClass: this.getColorClassForEntry(entry)
        }
      });
    },
    stressReliefGoalFormReportDate() {
      return this.stressReliefGoalForm ? moment(this.stressReliefGoalForm.entryDate).format('DD/MM/YYYY') : null;
    },
  },
  methods: {
    loadData() {
      this.getStressReliefGoalForm();
    },
    async getStressReliefGoalForm() {
      this.stressReliefGoalForm = await this.$app.questionnaireManager.getActivePatientQuestionnaire(this.patientId, 'STRESSRELIEFGOALS')
    },
    getColorClassForEntry(entry) {
      const answer = entry.givenAnswers[0].key;

      if (['NOT_AT_ALL', 'NOT_VERY_MOTIVATED'].includes(answer)) {
        return 'status-red';
      }
      if (answer === 'NEUTRAL') {
        return 'status-orange'
      }
      if (['MOTIVATED', 'VERY_MOTIVATED'].includes(answer)) {
        return 'status-green'
      }

      return '';
    }
  },
  watch: {
    patientId: function () {
      this.loadData();
    },
  }
}
</script>

<style lang="scss" scoped>
.status {
  min-height: 60px;
  color: black;
  border: none !important;
  line-height: 1.7;
}
</style>